import { MoMABalanceText } from 'sol';

export default class PaginationCallbacks {
  constructor(props) {
    this.el = props.el;
    this.beforeEls = [];
    this.newEls = [];
    this.momaBT = new MoMABalanceText();
  }

  balanceTextElements() {
    return [].slice.call(this.el.getElementsByClassName('balance-text'));
  }

  before() {
    this.beforeEls = this.balanceTextElements();
  }

  after() {
    const afterEls = this.balanceTextElements();
    this.newEls = afterEls.filter(e => !this.beforeEls.includes(e));
    this.beforeEls = null;
    this.momaBT.balance(this.newEls);
  }
}
